export default __webpack_public_path__ + "static/hawker-750-hb-68-7f2ba3f6dccdd3a71b9d7100028de31d.jpg";